type LogType = 'info' | 'error' | 'warn' | 'debug';
type LogArgs = Parameters<Console['log']>;

function emit(type: LogType, ...args: LogArgs): void {
  if (process.env.NODE_ENV === 'production') {
    return;
  }

  if (type === 'info') {
    args.unshift('🚀 [INFO]');
    console.info(...args);
    return;
  }

  if (type === 'warn') {
    args.unshift('⚠️ [WARN]');
    console.warn(...args);
    return;
  }

  if (type === 'error') {
    args.unshift('❌ [ERROR]');
    console.error(...args);
    return;
  }

  if (type === 'debug') {
    args.unshift('🐛 [DEBUG]');
    console.debug(...args);
    return;
  }
}

type LogFn = ((type: LogType, ...args: LogArgs) => void) & {
  info: (...args: LogArgs) => void;
  error: (...args: LogArgs) => void;
  warn: (...args: LogArgs) => void;
  debug: (...args: LogArgs) => void;
};

export const log: LogFn = Object.assign((type: LogType, ...args: LogArgs) => emit(type, ...args), {
  info: (...args: LogArgs) => emit('info', ...args),
  error: (...args: LogArgs) => emit('error', ...args),
  warn: (...args: LogArgs) => emit('warn', ...args),
  debug: (...args: LogArgs) => emit('debug', ...args)
});
